'use client'

import type { FC } from 'react'
import SelectMenu from 'components/SelectMenu'
import { Label } from 'ui/label'
import FieldWrapper from './FieldWrapper'
import type { FieldRendererProps } from './types'

export const selectFieldConfig = {
    getInitialValue: (field: TFormField) =>
        field.defaultValue || (field.options?.length ? field.options[0].id : '')
} satisfies Partial<import('./types').FieldTypeConfig>

const SelectField: FC<FieldRendererProps> = ({ field, value, error, onChange }) => {
    const resolvedValue =
        typeof value === 'object' && value !== null && 'id' in value
            ? (value as { id: string }).id
            : value

    return (
        <FieldWrapper fieldName={field.name} error={error}>
            <Label htmlFor={field.name}>{field.label}</Label>
            <SelectMenu
                disabled={!!field?.disabled}
                name={field.name}
                label={field.label as string}
                items={field.options || []}
                value={resolvedValue as string}
                set={v => onChange(field.name, v, field)}
                required={field.required}
            />
        </FieldWrapper>
    )
}

export default SelectField
